import utils from "@src/common/utils";

export const guFengPingAlarmOption = function () {
    return {
        add: "新增",
        edit: "修改",
        view: "查看",
        page: true,
        selection: true,
        radio: false,
        index: true,
        indexLabel: "序号",
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewFormSlot: true,
        labelSuffix: "：",
        size: "small",
        maxHeight: "100%",
        labelWidth: "140px",
        menuAlign: "center",
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 200,
        dialogWidth: "550px",
        emptyText: "暂无数据",
        column: [
            {
                label: "建筑名称",
                prop: "buildName",
                addDisplay: false,
                editDisplay: false,
                // viewDisplay: false,
                overHidden: true,
                search: false,
                searchSlot: false,
                clearable: true,
                searchPlaceholder: "请选择建筑名称",
                span: 12,
            },
            {
                label: "建筑",
                prop: "buildId",
                addDisplay: false,
                editDisplay: false,
                // viewDisplay: false,
                overHidden: false,
                hide: true,
                search: true,
                searchSlot: true,
                clearable: true,
                searchPlaceholder: "请选择建筑名称",
                span: 12,
            },
            {
                label: "预警名称",
                prop: "warningName",
                search: false,
                hide: true,
                addDisplay: false,
                editDisplay: false,
                // viewDisplay: false,
                overHidden: true,
                clearable: true,
                searchPlaceholder: "请输入预警名称",
                span: 12,
            },
            {
                label: "预警阈值",
                prop: "threshold",
                search: false,
                addDisplay: false,
                editDisplay: false,
                // viewDisplay: false,
                overHidden: true,
                // searchPlaceholder: '请输入部门',
                span: 12,
            },
            {
                label: "实际数值",
                prop: "actualValue",
                search: false,
                addDisplay: false,
                editDisplay: false,
                // viewDisplay: false,
                overHidden: true,
                // searchPlaceholder: '请输入部门',
                span: 12,
            },
            {
                label: "类型",
                prop: "type",
                search: false,
                addDisplay: false,
                editDisplay: false,
                // viewDisplay: false,
                overHidden: true,
                // searchPlaceholder: '请输入部门',
                span: 12,
                formatter: (row, value) => {
                    if (value === 0) {
                        return '谷时告警'
                    } else if (value === 1) {
                        return '平时告警'
                    } else {
                        return '峰时告警'
                    }
                }
            },
            {
                label: "时间段",
                prop: "timeSlot",
                search: false,
                addDisplay: false,
                editDisplay: false,
                // viewDisplay: false,
                overHidden: true,
                // searchPlaceholder: '请输入部门',
                span: 12,
            },
            {
                label: "告警时间",
                prop: "alarmTime",
                search: false,
                addDisplay: false,
                editDisplay: false,
                // viewDisplay: false,
                overHidden: true,
                // searchPlaceholder: '请输入部门',
                span: 12,
                formatter: function (row, value) {
                    return value
                        ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
                        : "";
                },
            },
        ],
    };
};
